import { Paper, Typography, Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function GridCardItem({ title, url, newTab }) {
    const handleClick = () => {
        if (newTab) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    };

    return (
        <Paper
            elevation={3}
            sx={{
                backgroundColor: "#fff",
                padding: 3,
                cursor: "pointer",
                borderRadius: 2,
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 6,
                },
            }}
            onClick={handleClick}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {title}
                </Typography>

                {newTab ? (
                    <OpenInNewIcon sx={{ fontSize: 20, color: "text.secondary" }} />
                ) : (
                    <ArrowForwardIosIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                )}
            </Box>
        </Paper>
    );
}

export default GridCardItem;
 